export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0,
  }).format(amount);
};

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('en-IN', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  }).format(date);
};

export const formatDateTime = (dateString) => {
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('en-IN', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
};

export const getPaymentStatus = (dueDate, currentStatus) => {
  if (currentStatus === 'paid') return 'paid';
  const due = new Date(dueDate);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  
  if (due < today) return 'overdue';
  return 'pending';
};

export const getDaysUntilDue = (dueDate) => {
  const due = new Date(dueDate);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const diffTime = due - today;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return diffDays;
};

export const isPaymentUpcoming = (dueDate, days = 7) => {
  const daysUntil = getDaysUntilDue(dueDate);
  return daysUntil >= 0 && daysUntil <= days;
};

export const calculateProjectStats = (projects) => {
  let totalReceived = 0;
  let totalPending = 0;
  let totalOverdue = 0;
  let upcomingPayments = [];
  let overduePayments = [];

  projects.forEach((project) => {
    project.paymentSchedule.forEach((payment) => {
      const status = getPaymentStatus(payment.dueDate, payment.status);
      
      if (status === 'paid') {
        totalReceived += payment.amount;
      } else if (status === 'overdue') {
        totalOverdue += payment.amount;
        overduePayments.push({ ...payment, project });
      } else {
        totalPending += payment.amount;
        if (isPaymentUpcoming(payment.dueDate, 30)) {
          upcomingPayments.push({ ...payment, project });
        }
      }
    });
  });

  return {
    totalReceived,
    totalPending,
    totalOverdue,
    upcomingPayments,
    overduePayments,
  };
};

export const getPaymentTypeLabel = (type) => {
  const labels = {
    outsourced: 'Outsourced Project',
    recurring: 'Recurring Payment',
    'one-time': 'One-time Payment',
  };
  
  // Check for custom payment types
  if (!labels[type]) {
    try {
      const customTypes = JSON.parse(localStorage.getItem('customPaymentTypes') || '[]');
      const customType = customTypes.find(ct => ct.value === type);
      if (customType) return customType.label;
    } catch (e) {
      console.error('Error parsing custom payment types:', e);
    }
  }
  
  return labels[type] || type;
};